export const useAuthStore = defineStore('auth', () => {
    const errorMessage = ref<string>('');
    const isShowSendVerifyEmailLink = ref<boolean>(false);

    const getErrorMessage = computed((): string => errorMessage.value);
    const getIsShowSendVerifyEmailLink = computed((): boolean => isShowSendVerifyEmailLink.value);

    return {
        errorMessage,
        isShowSendVerifyEmailLink,
        getErrorMessage,
        getIsShowSendVerifyEmailLink,
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
